import { render, staticRenderFns } from "./SubCurated.vue?vue&type=template&id=7d25a694&"
import script from "./SubCurated.vue?vue&type=script&lang=js&"
export * from "./SubCurated.vue?vue&type=script&lang=js&"
import style0 from "./SubCurated.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports